module.exports = __webpack_public_path__ + "img/before-scan.3a1ec5f6.svg";